import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import HeroSection from "@/components/home/HeroSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import ProductsSection from "@/components/home/ProductsSection";
import AboutSection from "@/components/home/AboutSection";
import CTASection from "@/components/home/CTASection";
import { Helmet } from "react-helmet";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>New Business - أبواب WPC المقاومة للماء والرطوبة</title>
        <meta name="description" content="أبواب خشبية مركبة عصرية بأسعار تنافسية، تركيب احترافي وضمان الجودة في الرياض" />
        <meta name="keywords" content="أبواب WPC, أبواب خشبية مركبة, أبواب مقاومة للماء, أبواب الرياض, تركيب أبواب, أبواب CNC, أبواب ديكورية" />
        <meta name="author" content="New Business" />
        <meta property="og:title" content="New Business - أبواب WPC المقاومة للماء والرطوبة" />
        <meta property="og:description" content="أبواب خشبية مركبة عصرية بأسعار تنافسية، تركيب احترافي وضمان الجودة في الرياض" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.newbusiness.com.sa" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="New Business - أبواب WPC المقاومة للماء والرطوبة" />
        <meta name="twitter:description" content="أبواب خشبية مركبة عصرية بأسعار تنافسية، تركيب احترافي وضمان الجودة في الرياض" />
        <link rel="canonical" href="https://www.newbusiness.com.sa" />
      </Helmet>
      
      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <ProductsSection />
          <AboutSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
